<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="admin-list-manager-title">
                {{ $t('admin.list_manager_meta.list.title') }}
            </div>
        </div>
        <list-manager-meta-table
            ref="ListManagerMetaTable"
            :selected_row_keys="selected_row_keys"
            @onSelectChange="onSelectChange"
            @onTableAction="onTableAction"
        />
        <a-drawer
            data-cy="list-manager-meta-drawer"
            :title="$t('admin.list_manager_meta.drawer.title')"
            :width="500"
            :open="drawer_visible"
            :body-style="{ padding: '0px', paddingBottom: '10px' }"
            :destroyOnClose="true"
            :maskClosable="false"
            :rootClassName="'epic-' + moduleStateLink"
            @close="onDrawerClose"
        >
            <form-list-manager-meta
                :record_type="record_type"
                :list_manager_meta="list_manager_meta"
                :processing="processing"
                :validation="validation"
                @is-form-dirty="isFormDirty"
                @formSubmit="onSave"
                @onDrawerClose="onDrawerClose"
            />
        </a-drawer>
    </div>
</template>

<script>
import FormListManagerMeta from '@/components/forms/ListManagerMeta.vue';
import ListManagerMetaTable from '@/components/tables/ListManagerMeta.vue';

export default {
    components: {
        FormListManagerMeta,
        ListManagerMetaTable,
    },
    props: {
        is_form_dirty: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            drawer_visible: false,
            record_type: 'new',
            list_manager_meta: {},
            selected_row_keys: [],
            validation: {
                errors: {},
                message: '',
            },
            processing: false,
        };
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
    },
    methods: {
        isFormDirty(is_form_dirty) {
            this.$emit('is-form-dirty', is_form_dirty);
        },
        onSelectChange(selected_row_keys) {
            this.selected_row_keys = selected_row_keys;
        },
        onTableAction(data) {
            switch (data.key) {
                case 'edit':
                    this.openDrawer({ id: data.id });
                    break;
            }
        },
        openDrawer(record) {
            if (!_.isEmpty(record) && record.id !== null) {
                const id = record.id;

                this.$http.get('/api/listmanagermeta/' + id).then((response) => {
                    this.list_manager_meta = {
                        ...response.data.data,
                    };
                    this.record_type = 'existing';

                    this.drawer_visible = true;
                });
            } else {
                this.list_manager_meta = {
                    category: '',
                    list_name: '',
                    list_description: '',
                    item: '',
                    value: '',
                    description: '',
                    flag_a: '',
                    flag_b: '',
                    flag_c: '',
                    option_a: '',
                    option_b: '',
                    option_c: '',
                    notes: '',
                };
                this.record_type = 'new';

                this.drawer_visible = true;
            }
        },
        onDrawerClose() {
            let can_close = true;

            if (this.is_form_dirty) {
                let that = this;
                can_close = false;

                this.$confirm({
                    title: this.$t('globals.navigation.notifications.unsaved_changes.title'),
                    content: this.$t('globals.navigation.notifications.unsaved_changes.content'),
                    onOk() {
                        that.isFormDirty(false);
                        that.drawer_visible = false;
                    },
                });
            }

            if (can_close) {
                this.isFormDirty(false);
                this.drawer_visible = false;
            }
        },
        onSave(data) {
            if (this.processing) {
                return false;
            }

            this.processing = true;

            let payload = data.data;

            if (data.type == 'new') {
                this.$http
                    .post('/api/listmanagermeta', payload)
                    .then((response) => {
                        this.isFormDirty(false);

                        this.$refs.ListManagerMetaTable.sorter = {
                            field: 'created_at',
                            order: 'descend',
                        };

                        this.$refs.ListManagerMetaTable.reload();

                        this.drawer_visible = false;
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.validation = error.response.data;
                        } else if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVLMMA01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            } else {
                let category = payload.category;

                this.$http
                    .put('/api/listmanagermeta/' + category, payload)
                    .then((response) => {
                        this.isFormDirty(false);

                        this.$refs.ListManagerMetaTable.reload();

                        this.drawer_visible = false;
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.validation = error.response.data;
                        } else if (error.response.status == 403) {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.403_mod'),
                            });
                        } else {
                            this.$notification.error({
                                message: this.$t('globals.global.notifications.error.any', { code: 'CVLMMU01' }),
                            });
                        }
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },
        reload() {
            this.$refs.ListManagerMetaTable.reload();
        },
    },
};
</script>
